import { render } from "./PageOverlay.vue?vue&type=template&id=43078eca"
import script from "./PageOverlay.vue?vue&type=script&lang=js"
export * from "./PageOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__